import { ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IComparisonCountry } from "../interfaces/icomparisoncountry";
import { CountryComparisonService } from "../services/countrycomparison.service";
import { Observable, of } from "rxjs";


@Injectable()
export class CountryComparisonResolver {

    constructor(private countryComparisonSvc: CountryComparisonService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<IComparisonCountry | null> {
        if (route.params['countryCode']) {
            return this.countryComparisonSvc.getComparisonCountry(route.params['countryCode']);
        }
        return of(null);
    }
}